import type { Document } from "../../types/document";
import { DocumentCard } from "./DocumentCard";
import styles from "./DocumentGrid.module.css";

interface DocumentGridProps {
	documents: Document[];
	onDocumentClick: (document: Document) => void;
}

export function DocumentGrid({
	documents,
	onDocumentClick,
}: DocumentGridProps) {
	return (
		<div className={styles.grid}>
			{documents.map((document) => (
				<DocumentCard
					key={document.id}
					document={document}
					onClick={() => onDocumentClick(document)}
				/>
			))}
		</div>
	);
}
